module.exports = __webpack_public_path__ + "static/Pegasus-5bedd09b153c11822cfb063b6e11cd4a.jpg";